{
  "it": {
    "client": {
      "actions": {
        "changeBackgroundImage": "Cambia immagine di accesso",
        "new": "Nuova organizzazione",
        "setAsPrimary": "Imposta come principale",
        "submit": "Salva",
        "undoChanges": "Annulla modifiche"
      },
      "attributes": {
        "address": "Indirizzo",
        "aftercare_conversation_enabled": "Conversazioni post-vendita",
        "backgroundImage": "Immagine della schermata di accesso",
        "email_address": "Email",
        "email_address_invoicing": "Email di fatturazione",
        "email_address_renewal": "Email di promemoria per il rinnovo del contratto",
        "email_address_reply_to": "Indirizzo email \"Rispondi a\"",
        "email_address_ziggu": "Indirizzo email \"Da\"",
        "iban": "IBAN",
        "language": "Lingua",
        "languages": "Lingue dell'organizzazione",
        "name": "Nome",
        "phone": "Telefono",
        "storage_sum": "Spazio utilizzato",
        "storage_sum_max": "{percentage}% di {gigabytes} GB",
        "subdomain": "Sottodominio",
        "timezone": "Fuso orario",
        "vat_number": "Partita IVA"
      },
      "client_types": {
        "architects_designers": "Architetti e designer",
        "creative_agencies": "Agenzie creative",
        "general_specialized_contractors": "Imprese edili generali e specializzate",
        "makers_manufacturers": "Artigiani e produttori",
        "planners_coordinators": "Pianificatori e coordinatori",
        "property_developers": "Sviluppatori immobiliari"
      },
      "integrations": {
        "api_docs_info": "Per maggiori informazioni sulla nostra API, visiti la nostra",
        "api_documentation": "Documentazione API"
      },
      "labels": {
        "activeProjects": "Progetti attivi",
        "activeProjectsUsed": "{0} progetti attivi, {1} non ancora utilizzati",
        "activeUnits": "Unità attive",
        "activeUnitsUsed": "{0} unità attive, {1} non ancora utilizzate",
        "after_care_categories": "Categorie",
        "after_care_statuses": "Stati",
        "aftercare": "Post-vendita",
        "bookADemo": "Prenota una demo",
        "by": "Di {client}",
        "categories": "Categorie",
        "category": "Categoria",
        "chatWithUs": "Chatta con noi",
        "companyProfile": "Profilo organizzazione",
        "contactIntercom": "Ci contatti tramite la chat se desidera modificarlo.",
        "contactZiggu": "Ha una domanda per Ziggu? È bloccato con qualcosa? Vuole un consiglio sul prodotto? Chattiamo.",
        "conversations": "Conversazioni",
        "dashboard": "Dashboard",
        "decisions": "Decisioni",
        "default_payment_overdue": "Ha una fattura scaduta per Ziggu. La paghi immediatamente per evitare interessi. Ha domande? Non esiti a contattarci.",
        "delete_category": "Eliminare la categoria {category}?",
        "delete_category_expl": "L'eliminazione di una categoria di documenti non può essere annullata. I documenti esistenti con questa categoria verranno spostati nella categoria Altro",
        "document_categories": "Categorie",
        "documents": "Documenti",
        "email_address_invoicing_info": "Invieremo le nuove fatture a questo indirizzo.",
        "email_address_renewal_info": "Invieremo email a questo indirizzo quando si avvicina la data di rinnovo del Suo abbonamento, per informarla con tutte le informazioni necessarie.",
        "email_address_reply_to": "Questo indirizzo email verrà utilizzato se qualcuno risponde a un'email inviata tramite {email_address_ziggu}. Ci contatti tramite la chat se desidera modificarlo.",
        "email_address_ziggu": "Questo indirizzo email verrà utilizzato come indirizzo mittente (\"Da\") di tutte le email inviate tramite la piattaforma (email relative a notifiche, inviti, reimpostazioni della password, ...)",
        "email_forwarder_must_be_owner": "Solo i membri del team con ruolo 'Proprietario' possono inoltrare le email.",
        "email_forwarding_activated": "L'inoltro delle email è attivo",
        "email_forwarding_activated_project": "L'inoltro delle email del progetto è attivo",
        "email_forwarding_disclaimer": "Per prevenire lo spam, vengono elaborate solo le email inviate da un indirizzo collegato a un <b>profilo Proprietario/Gestore esistente</b>.<br>Le email da mittenti sconosciuti verranno ignorate.",
        "email_forwarding_is": "Il Suo indirizzo di inoltro è",
        "financials": "Finanze",
        "general": "Generale",
        "goToSettings": "Impostazioni",
        "helpcenter": "Centro assistenza",
        "inbound_email": "Email in arrivo",
        "invoice_overdue": "Ha un pagamento in ritardo. Contatti accounting{'@'}ziggu.io per ulteriori informazioni.",
        "invoice_overdue_title": "Fattura scaduta",
        "language": "Questa è la lingua predefinita dell'organizzazione per la Sua pagina di accesso, i clienti e i membri del team.",
        "languages": "La lingua principale è quella predefinita per l'inserimento dei contenuti e non può essere rimossa. Aggiunga altre lingue per supportare contenuti multilingue. Faccia clic su una lingua aggiuntiva per renderla quella principale.",
        "mobile_app_disabled": "App mobile (PWA) non attiva",
        "mobile_app_enabled": "App mobile (PWA) attiva",
        "mobile_app_info": "Ci scriva su Intercom per maggiori informazioni.",
        "mustBeJPG": "Deve essere un'immagine .jpg",
        "new_categories": "Categorie aggiuntive",
        "new_document_category": "Categoria",
        "noCategories": "Non ha ancora nessuna categoria. Ne crei una per iniziare.",
        "other": "Altro",
        "outOfOffice": "Fuori sede",
        "outOfOfficeMessage": "Messaggio di fuori sede (opzionale)",
        "packageUnits": "Abbonamento per",
        "primary": "Principale",
        "removed_user": "Utente rimosso",
        "settings": {
          "click_to_copy": "Faccia clic per copiare il token negli appunti",
          "copied_to_clipboard": "Token copiato negli appunti"
        },
        "snippets": "Frammenti",
        "subscription": "Abbonamento",
        "subscriptionRenewalDate": "Data di rinnovo",
        "subscriptionUsageUnits": "Utilizzo attuale",
        "tab_aftercare": "Post-vendita",
        "tab_billing": "Fatturazione",
        "tab_branding": "Branding",
        "tab_features": "Funzionalità",
        "tab_general": "Generale",
        "tab_information": "Informazioni",
        "tab_integrations": "Integrazioni",
        "tickets": "Conversazioni",
        "timezone": "Questo è il fuso orario predefinito dell'organizzazione.",
        "translation_not_added_yet": "La traduzione non è ancora stata aggiunta",
        "unchangeable_categories": "Categorie predefinite non modificabili",
        "unchangeable_categories_info": "Queste categorie sono necessarie per il corretto funzionamento del sistema o vengono utilizzate nelle integrazioni.",
        "upgradePackageContactUs": "Ci contatti per iniziare",
        "upgradePackageSubtitleAftercare": "Questa funzionalità Le permette di seguire i clienti dopo la consegna e aiutarli a risolvere eventuali problemi nella loro nuova casa",
        "upgradePackageSubtitleConversationMentions": "Questa funzionalità Le permette di scrivere note private e taggare i membri del team in una conversazione",
        "upgradePackageSubtitleFinancials": "Crei una panoramica finanziaria per ogni acquirente in un istante",
        "upgradePackageSubtitleMilestones": "Questa funzionalità Le permette di comunicare in modo semplice l'avanzamento dei lavori al Suo cliente",
        "upgradePackageSubtitleMultipleCustomerSingleUnit": "Questa funzionalità Le permette di invitare un secondo acquirente sulla piattaforma Ziggu",
        "upgradePackageTitle": "Sembra che non disponga ancora di questa funzionalità",
        "warningooo": "Fuori sede attivo",
        "yourEmail": "La Sua email",
        "zigguHome": "Ziggu Home"
      },
      "project_types": {
        "mup": "MUP",
        "sup": "SUP"
      },
      "toasts": {
        "attachment_category": {
          "create": "Categoria documento creata",
          "update": "Categoria documento aggiornata"
        }
      },
      "validation": {
        "attachment_category_required": "La categoria è obbligatoria",
        "duplicated_translation": "Traduzione duplicata",
        "mustBeEmailAddress": "Deve essere un indirizzo email",
        "needName": "Il nome è obbligatorio"
      }
    }
  }
}
